import { RootState } from '../../../store';

export const selectOrdersRecognitionSidebarMode = (s: RootState) =>
    s.ordersRecognitionSidebarReducer.mode;
